module.exports = __webpack_public_path__ + "img/starfull1.a86913b5.png";